module.exports = __webpack_public_path__ + "media/images/list-bullet-5e3ac5899b2adec5e73f0f2e0fff1bcb.svg";